function toggleNotifyForm(button) {
  const formBox = document.getElementById("notifyFormBox");
  const isVisible = formBox.style.display === "block";
  formBox.style.display = isVisible ? "none" : "block";
  button.classList.toggle("expanded", !isVisible);
}

function extractEnglishWorkshopTitle(title) {
  if (!title) {
    return "";
  }

  const cleaned = String(title).replace(/#/g, " ").replace(/\s+/g, " ").trim();
  const match = cleaned.match(/([A-Za-z][A-Za-z0-9&'()\-\/\s]*Workshop)/i);
  return match && match[1] ? match[1].replace(/\s+/g, " ").trim() : cleaned;
}

function applyWorkshopTitle(notifyForm) {
  const rawTitle = notifyForm.getAttribute("data-product-title") || "";
  const englishTitle = extractEnglishWorkshopTitle(rawTitle);
  if (!englishTitle) {
    return;
  }

  const displayField = document.getElementById("notifyWorkshopDisplay");
  const hiddenField = document.getElementById("notifyWorkshopValue");

  if (displayField) {
    displayField.value = englishTitle;
  }

  if (hiddenField) {
    hiddenField.value = englishTitle;
  }
}

function initNotifyForm() {
  const notifyForm = document.getElementById("notifyForm");
  if (!notifyForm || notifyForm.dataset.notifyBound === "true") {
    return;
  }

  notifyForm.dataset.notifyBound = "true";
  applyWorkshopTitle(notifyForm);

  notifyForm.addEventListener("submit", function (e) {
    e.preventDefault();

    if (notifyForm.dataset.submitting === "true") {
      return;
    }

    notifyForm.dataset.submitting = "true";

    const submitButton = notifyForm.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
    }

    const formData = new FormData(notifyForm);

    fetch("https://n8n-rqkz.onrender.com/webhook/92ba0802-5693-43ce-a9d9-692cdf5653d7", {
      method: "POST",
      body: formData
    })
      .then(response => {
        if (response.ok) {
          const messageBox = document.getElementById("successMessage");
          if (messageBox) {
            messageBox.textContent = "Submitted. Thank you!";
            messageBox.style.display = "block";
          }
          notifyForm.reset();
          applyWorkshopTitle(notifyForm);
        } else {
          alert("Submission failed. Please try again.");
        }
      })
      .catch(() => {
        alert("Something went wrong. Please try again.");
      })
      .finally(() => {
        notifyForm.dataset.submitting = "false";
        if (submitButton) {
          submitButton.disabled = false;
        }
      });
  });
}

document.addEventListener("DOMContentLoaded", initNotifyForm);
document.addEventListener("shopify:section:load", initNotifyForm);
initNotifyForm();